import axios from 'axios'

export default {
  addNdaDocument (mnemo, formData) {
    const requestConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }

    return axios.post(`/room/${mnemo}/nda`, formData, requestConfig)
  },
  validateNdaDocument (mnemo) {
    return axios.post(`/room/${mnemo}/nda/validate`)
  },
}
